import { Injectable } from '@angular/core';
import { apiUrl, resolveApiAssets } from '../config/api';
import { Team } from '../models/team';

@Injectable({ providedIn: 'root' })
export class TeamService {
  private readonly apiUrl = apiUrl('/api/teams');

  list(): Promise<Team[]> {
    return this.request<Team[]>(this.apiUrl);
  }

  get(id: number): Promise<Team> {
    return this.request<Team>(`${this.apiUrl}/${id}`);
  }

  create(team: Partial<Team>): Promise<Team> {
    return this.request<Team>(this.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(team)
    });
  }

  update(id: number, team: Partial<Team>): Promise<Team> {
    return this.request<Team>(`${this.apiUrl}/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(team)
    });
  }

  async delete(id: number): Promise<void> {
    await this.request<{ success: boolean }>(`${this.apiUrl}/${id}`, { method: 'DELETE' });
  }

  async deleteAll(): Promise<void> {
    await this.request<{ success: boolean }>(this.apiUrl, { method: 'DELETE' });
  }

  private async request<T>(url: string, init?: RequestInit): Promise<T> {
    const response = await fetch(url, { cache: 'no-store', ...init });
    const data = await response.json().catch(() => null);

    if (!response.ok) {
      throw new Error(data?.error ?? 'Errore API');
    }

    return resolveApiAssets(data as T);
  }
}
